/**
 * Guía: Ingresos por Creador.
 *
 * Contenido derivado del capítulo **25** del manual: §0 (las tres pantallas
 * de un creador y para qué es cada una).
 *
 * Corta porque es de sólo lectura. Su valor está en no confundirla con las
 * otras dos, que es lo que produce «entré a pagarle y no había nada».
 */

import type { TourFlow } from '../types';

const INGRESOS_CREADOR_PATH = '/finance-creators';

export const c25IngresosPorCreador: TourFlow = {
  id: 'admin.finance-creators',
  chapter: '25',
  title: 'Ingresos por creador',
  summary:
    'Cuánto ha generado cada creador, y en qué se diferencia de sus otras dos pantallas.',
  href: INGRESOS_CREADOR_PATH,
  requiresCountry: true,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Un creador tiene tres pantallas',
      body:
        'Creadores de Contenido es su alta y su estado. Pagos a Creadores es donde se le ' +
        'liquida. Ésta dice **cuánto ha generado**, y es de sólo lectura.',
      route: INGRESOS_CREADOR_PATH,
    },
    {
      id: 'generated-is-not-paid',
      title: 'Generado no es cobrado',
      body:
        'Lo que aparece aquí es lo que sus supporters produjeron. Lo que ya se le transfirió ' +
        'sale en su pantalla de pagos. Compararlas sin esa distinción lleva a creer que se ' +
        'le debe de más o de menos.',
      target: 'admin.financeCreators.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'only-active-earns',
      title: 'Un creador suspendido no genera',
      body:
        'Deja de devengar mientras esté suspendido, pero conserva lo anterior y lo cobra al ' +
        'reactivarse. Una cifra que se queda quieta suele ser eso.',
    },
  ],
};
